import { 
    LOAD_LIST_PATIENT_RESULT, LOAD_A_PATIENT_RESULT, ADD_NEW_PATIENT_RESULT, UPDATE_A_PATIENT_RESULT, DELETE_A_PATIENT_RESULT, 
    CLEAR_A_PATIENT_RESULT_DETAIL, CLEAR_PATIENT_RESULT_ACTION_STATUS,
    EXPORT_MEDICINE_TO_PDF, CLEAR_MEDICINE_TO_PDF
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    patientResultList: [],
    patientResultDetail: null,
    remotePDF: null,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: ""
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_PATIENT_RESULT: {
            return {
                ...state,
                patientResultList: action.payload,
            }
        }

        case LOAD_A_PATIENT_RESULT: {
            return {
                ...state,
                patientResultDetail: action.payload
            }
        }

        case ADD_NEW_PATIENT_RESULT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                patientResultList: [
                    action.payload.data,
                    ...state.patientResultList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_PATIENT_RESULT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                patientResultList: state.patientResultList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_PATIENT_RESULT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                patientResultList: state.patientResultList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_PATIENT_RESULT_DETAIL: {
            return {
                ...state,
                patientResultDetail: null,
            }
        }
        
        case CLEAR_PATIENT_RESULT_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        case EXPORT_MEDICINE_TO_PDF:
            return {
                ...state,
                remotePDF: action.payload,
            };

        case CLEAR_MEDICINE_TO_PDF: {
            return {
                ...state,
                remotePDF: null
            }
        }
            

        default:
            return state
    }
}